angular.module('app.balance', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload', 'bw.paging'])
.config(['$routeProvider', ($routeProvider) => {
  $routeProvider.when('/balance', {
    template: require('./balance.html'),
    controller: 'balanceCtrl',
  });
}])
.controller('balanceCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $routeParams, $window, AuthService, envService) => {
  $rootScope.mainmenu = 'balance';
  $rootScope.menu = 'list';
  $scope.gShowOrderView = $rootScope.gShowOrderView;
  $scope.showAll = false;
  $scope.include_unregister = false;
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }
  $scope.fetchEmployees = () => {
    $resource(`${APIURL}/admin/employees`).get({ count: 10000, include_unregister: $scope.include_unregister }, (data) => {
      $scope.employees = data.users;
      $scope.targetEmployeeId = $scope.employees[0].ID.toString();
      $scope.employeeChanged();
      console.log(data);
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.employeeChanged = () => {
    $resource(`${APIURL}/admin/employees/${$scope.targetEmployeeId}/balances/months`).get((data) => {
      $scope.months = data.months;
      $scope.targetMonth = $scope.months[0];
      $scope.monthChanged();
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.monthChanged = () => {
    $resource(`${APIURL}/admin/employees/${$scope.targetEmployeeId}/balances?MONTH=${$scope.targetMonth}&SHOW_ALL=${$scope.showAll}`).get((data) => {
      console.log(data);
      $scope.balance = data;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.viewModifyModal = (order) => {
    $scope.modifyTargetOrder = jQuery.extend({}, order);
    jQuery('#modal-modify').modal('show');
  };

  $scope.modify = (targetOrder) => {
    $resource(`${APIURL}/admin/employees/${$scope.targetEmployeeId}/balances/${targetOrder.ORDER_NO}/payment`).save(targetOrder, () => {
      for (let idx = 0; idx < $scope.balance.orders.length; idx += 1) {
        const order = $scope.balance.orders[idx];
        if (order.ORDER_NO === targetOrder.ORDER_NO) {
          order.EMPLOYEE_PAYMENT_YN = targetOrder.EMPLOYEE_PAYMENT_YN;
          break;
        }
      }
      jQuery('#modal-modify').modal('hide');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.viewModifyPriceModal = (order, label) => {
    $scope.modifyTargetOrder = jQuery.extend({}, order);
    let value;
    let path;
    if (label === '상품') {
      value = order.GOODS_PRICE;
      path = 'goodsPrice';
    } else if (label === '고객 실 결제금액') {
      value = order.TOTAL_PRICE;
      path = 'totalPrice';
    } else if (label === '정산기준 금액') {
      value = order.DEFAULT_PRICE;
      path = 'defaultPrice';
    } else if (label === '개인 정산금액') {
      value = order.BALANCE;
      path = 'balance';
    } else if (label === '팀 정산 기준금액') {
      value = order.DEFAULT_TEAM_PRICE;
      path = 'defaultTeamPrice';
    }
    $scope.modifyType = { label, value, path };
    console.log($scope.modifyType);
    jQuery('#modal-modify-price').modal('show');
  };

  $scope.modifyPrice = (targetOrder) => {
    $resource(`${APIURL}/admin/employees/${$scope.targetEmployeeId}/balances/${targetOrder.ORDER_NO}/${$scope.modifyType.path}`).save($scope.modifyType, () => {
      $scope.monthChanged();
      jQuery('#modal-modify-price').modal('hide');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };


  $scope.viewModifyOptionModal = (order) => {
    console.log(order);
    $scope.modifyTargetOrder = jQuery.extend({}, order);
    jQuery('#modal-modify-option').modal('show');
  };

  $scope.modifyOption = (targetOrder) => {
    const optionsPrices = targetOrder.OPTIONS.map(option => option.OPTION_PRICE).join(',');
    $resource(`${APIURL}/admin/employees/${$scope.targetEmployeeId}/balances/${targetOrder.ORDER_NO}/optionsPrices`).save({ value: optionsPrices }, () => {
      $scope.monthChanged();
      jQuery('#modal-modify-option').modal('hide');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.fetchEmployees();
});



// WEBPACK FOOTER //
// ./src/app/balance/balance.js